/**
 * All possible values we can use.
 * We put them here so we can use them as an enum values.
 */
export const MonthValues = {
  Twelve: '12',
  Six: '6',
  Three: '3',
};
